import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Inventory from 'components/sales/inventory/inventory';
import SoftwareInventory from '../SoftwareInventory/SoftwareInventory';

const MaterialHardware = ({
  data,
  handleValue,
  handleGatesData,
  handleProductData,
  getMaterial,
  getBrandById,
  getBrand,
  getMateriaById,
  postSalesData,
  commData,
  inventoryMaster,
  requiredDocumentsDropdown,
  handleRequiredValues,
  solutionType,
  inventoryEditable,
  handleSoftwareInventory
}) => {
  const { materialHardwareRequired } = data;
  const MaterialInputs = {
    materialHardwareReq1: '',
  };
  const [materialData, setMaterialData] = useState(MaterialInputs);
  const [hardwareData, setHardwareData] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]); 

  useEffect(() => {
    if (postSalesData?.material_hardware?.prod_array != null && postSalesData?.material_hardware?.prod_array !== undefined) {
      setMaterialData({ 
        materialHardwareReq1: postSalesData.material_hardware.prod_array.length > 0 
        ? { id: "yes", value: "Yes" } 
        : { id: "no", value: "No" } 
      });
    }
  }, [postSalesData]);

  useEffect(() => {
    const materialObj = {
      materialHardwareReq: materialData.materialHardwareReq1.id,
    };
    const isNotEmpty = handleValidateObj(materialObj);
    if (isNotEmpty !== false) {
      const dataValue = { materialHardwareReq: materialData?.materialHardwareReq1?.id };
      handleValue(dataValue);
    } else {
      handleValue(null);
    }
  }, [materialData, materialData?.materialHardwareReq1?.id]);

  const handleDocumentSelection = (selectedItems) => {
    const normalizedItems = Array.isArray(selectedItems) ? selectedItems : [selectedItems];
    const selectedIds = normalizedItems.map((item) => item.id);
    setSelectedDocuments(selectedIds);
    handleRequiredValues({ selectedDocuments: selectedIds });
  };
  

  return (
    <Fragment>
      <FormSection title={localization.materialHardware}>
        <DropDownInput
          getIdValue={(val) => setMaterialData({ materialHardwareReq1: val })}
          data={materialHardwareRequired}
          label={localization.materialHardwareReq}
          required
          isStarRequired={true}
          errorMsg={localization.requiredmaterialHardwareReq}
          value={materialData?.materialHardwareReq1?.value}
        />
      </FormSection>
      {materialData?.materialHardwareReq1?.value?.toLowerCase() == 'yes' ? (
        <Fragment>
          <Inventory
            data={data}
            handleGatesData={handleGatesData}
            handleProductData={handleProductData}
            getMaterial={getMaterial}
            getBrandById={getBrandById}
            getMateriaById={getMateriaById}
            getBrand={getBrand}
            postSalesData={postSalesData}
            editProduct={postSalesData?.hardware?.length>0?true:false}
            commData={commData}
            inventoryMaster={inventoryMaster} 
          />
          <SoftwareInventory 
            handleValue={handleSoftwareInventory} 
            data={data}
            postSalesData={postSalesData}
          />
        </Fragment>
      ) : null}
      {(parseInt(solutionType) === 5 || parseInt(solutionType) === 1 || parseInt(solutionType) === 2) && (
        <FormSection title={'Required Documents'}>
          <DropDownInput
            data={requiredDocumentsDropdown?.required_docs}
            label={'Select Documents'}
            required
            isStarRequired={true}
            errorMsg={localization.tags}
            multipule
            getIdValue={handleDocumentSelection}
            selectedList={requiredDocumentsDropdown?.mandatory_docs}
          />
        </FormSection>
      )}
    </Fragment>
  );
};

MaterialHardware.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func.isRequired,
  handleRequiredValues: PropTypes.func.isRequired,
};

export default MaterialHardware;